import React, { FormEvent, useEffect, useState } from 'react'

import useSaveNotificationFunction from '../../../hooks/notification_functions/useSaveNotificationFunction';
import useDeleteNotificationFunction from '../../../hooks/notification_functions/useDeleteNotificationFunction';

import { INotificationFunction, ISaveNotificationFunction } from '../../../types/custom_notifications';
import { IMetaFunction } from '../../../types/meta_function';

interface INotificationFunctionProps {
  notificationFunction: INotificationFunction;
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsResetNew: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModalMessage: React.Dispatch<React.SetStateAction<{ title: string; subtitle: string; }>>;
  metaFunctions: IMetaFunction[];
  isAction: boolean;
  setIsAction: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenModal: boolean;
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const NotificationFunction = ({ notificationFunction, currOption, setCurrOption, isDelete, setIsDelete, setIsOpenDeleteModal, setIsResetNew, setDeleteModalMessage, setIsOpenModal, isAction, setIsAction, metaFunctions }: INotificationFunctionProps) => {
  const [title, setTitle] = useState<string>(notificationFunction.id ? notificationFunction.description : 'New Notification Function');

  const [currentNotificationFunction, setCurrentNotificationFunction] = useState<INotificationFunction>(notificationFunction);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [apiError, setApiError] = useState<string | null>(null); //eslint-disable-line

  useEffect(() => {
    setCurrentNotificationFunction(notificationFunction);
    setTitle(notificationFunction.id ? notificationFunction.description : 'New Notification Function');
  }, [notificationFunction]);

  const { mutate: saveNotificationFunction } = useSaveNotificationFunction();
  const { mutate: deleteNotificationFunction } = useDeleteNotificationFunction();

  useEffect(() => {
    if (isAction) {
      saveNotificationFunction({
        data: {
          id: notificationFunction.id || null,
          notification_component_id: currentNotificationFunction.notification_component_id,
          name: currentNotificationFunction.name,
          description: currentNotificationFunction.description
        },
        setIsProcessing: setIsProcessing,
        setApiError: setApiError
      });
      setIsOpenModal(false);
      setIsAction(false);
      setTitle(currentNotificationFunction.name || 'New Notification Function');
    }
  }, [isAction]); //eslint-disable-line

  useEffect(() => {
    if (isDelete) {
      if (currOption.length - 1 === 2) {
        setCurrOption([currOption[0], currOption[1]]);
      } else {
        setCurrOption([currOption[0], currOption[1], 0]);
      }
      if (!notificationFunction.id) return;
      deleteNotificationFunction({
        id: notificationFunction.id,
        setIsProcessing: setIsProcessing,
        setApiError: setApiError
      });
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!currentNotificationFunction) {
    return <p>Loading...</p>
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    const payload: ISaveNotificationFunction = {
      id: currentNotificationFunction.id || null,
      notification_component_id: currentNotificationFunction.notification_component_id,
      name: currentNotificationFunction.name,
      description: currentNotificationFunction.description
    }

    if (!currentNotificationFunction.id || notificationFunction.name === currentNotificationFunction.name) {
      saveNotificationFunction({
        data: payload,
        setIsProcessing: setIsProcessing,
        setApiError: setApiError
      });
      setTitle(currentNotificationFunction.description || 'New Notification Function');
    } else {
      setIsOpenModal(true);
      setDeleteModalMessage({ title: 'Update Notification Function', subtitle: 'This action will delete all the parameters of older function. Do you want to continue?' })
    }
  }

  const handleDelete = () => {
    if (!notificationFunction.id) {
      setIsResetNew(true);
      if (currOption.length - 1 === 2) {
        setCurrOption([currOption[0], currOption[1]]);
      } else {
        setCurrOption([currOption[0], currOption[1], 0]);
      }
    } else {
      setDeleteModalMessage({ title: 'Delete Notification Function', subtitle: 'This will delete all the  parameters associated with the function. Are you sure you want to delete?' });
      setIsOpenDeleteModal(true);
    }
  }


  return (
    <div className='imm_admin__content'>
      <div className='content_head'>
        <h3>{notificationFunction.id ? 'Function - ' : ''}{title.slice(0, 40) + (title.length > 40 ? ' ...' : '')}</h3>
      </div>

      <form onSubmit={handleSave} className='content_form'>
        <div className='field'>
          <label htmlFor='meta_function'>Meta Function <span className='field__required'>*</span></label>
          <select id='meta_function' name='meta_function' value={currentNotificationFunction.name || -1} onChange={(e) => setCurrentNotificationFunction({ ...currentNotificationFunction, name: e.target.value })} >
            <option value={-1} disabled>Select meta function</option>
            {metaFunctions.map(metaFunction => {
              return <option key={metaFunction.name} value={metaFunction.name}>{metaFunction.name}</option>
            })}
          </select>
        </div>

        <div className='field'>
          <label htmlFor='description'>Description <span className='field__required'>*</span></label>
          <textarea id='description' name='description' placeholder='Enter Description' value={currentNotificationFunction.description || ""} onChange={(e) => setCurrentNotificationFunction({ ...currentNotificationFunction, description: e.target.value })}></textarea>
        </div>

        <div className='actions'>
          <button className='delete_btn' disabled={isProcessing} type="button" onClick={handleDelete}>{!notificationFunction.id ? 'Cancel' : 'Delete'}</button>
          <button className='save_btn' type='submit'>{isProcessing ? <i className='imm_admin__process_loader' /> : !notificationFunction.id ? 'Create' : 'Save'}</button>
        </div>
      </form>
    </div>
  );
}

export default NotificationFunction;